import type { IAction } from '~/src/store';
import { ActionTypesPromo } from '~/src/store/actionTypes/promo';
import type { IPromoStore } from '~/src/store/reducers/promo';

/**
 * Задать статус карточки акции в сторе
 *
 * @function
 * @name store.actionsCreators.promo.setStatusCard
 * @param {setStatusCard} status - статус карточки
 * @returns {IAction<typeof ActionTypesPromo.SET_CATEGORY_PROMO_CARD>}
 */
export const setStatusCard = (status: Record<number, IPromoStore>): IAction<typeof ActionTypesPromo.SET_CATEGORY_PROMO_CARD> => ({
    type: ActionTypesPromo.SET_CATEGORY_PROMO_CARD,
    payload: status,
});
